'use client';

import { Box, SimpleGrid } from '@chakra-ui/react';
import { Broker } from '@habity/types';
import { NoResults } from './components/NoResults';
import { placeholderBrokers } from '@habity/constants';
import { getBrokerPath } from '@habity/services';
import { Link } from '@chakra-ui/next-js';
import { useGridFullRows } from '~/hooks/useGridFullRows';
import { BrokerCardList } from '~/components/brokers/cards/List';

export const BrokersGrid = ({
  brokers: realBrokers,
  brokersLoading,
  hasMore,
}: {
  brokers?: Broker[] | null;
  brokersLoading: boolean;
  hasMore: boolean;
}) => {
  // Add placeholders for the initial loading state if tab is activated
  // Placeholders for new page loading are handled within the useObserver hook
  const brokers =
    brokersLoading && realBrokers && realBrokers.length === 0
      ? placeholderBrokers
      : realBrokers && realBrokers.length > 0
      ? realBrokers
      : [];

  const { gridRef, visibleItems: visibleBrokers } = useGridFullRows(
    brokers,
    hasMore
  );

  if (!visibleBrokers || !visibleBrokers.length) {
    return <NoResults tab="brokers" />;
  }

  return (
    <SimpleGrid
      ref={gridRef}
      columns={{ mobile: 1, tablet: 2, desktop: 3 }}
      rowGap="10"
      columnGap="5"
      pt="4"
      pb="12"
    >
      {visibleBrokers.map((broker, i) => (
        <BrokerCardList key={i} broker={broker} isLoading={!!broker?.loading} />
      ))}
    </SimpleGrid>
  );
};
